import Vue from 'vue';

let serverResolution = null;

export default {
  getAvailableBaseServer(base_server, base_fallback, is_homolog) {
    if (!serverResolution) {
      serverResolution = this.resolveAvailableBaseServer(base_server, base_fallback, is_homolog);
    }

    return serverResolution;
  },

  async resolveAvailableBaseServer(base_server, base_fallback, is_homolog) {
    if (is_homolog || await this.checkServerHealth(base_server)) {
      return { base_server, server_available: true };
    }

    if (base_fallback && base_fallback !== base_server && await this.checkServerHealth(base_fallback)) {
      sessionStorage.setItem('base_server', base_fallback);
      return { base_server: base_fallback, server_available: true };
    }

    return { base_server, server_available: false };
  },

  async checkServerHealth(base_server) {
    try {
      const health_url = base_server.replace(/\/?$/, '/') + 'health';
      await Vue.http.get(health_url, { timeout: 5000 });
      return true;

    } catch (error) {
      return false;
    }
  }
};
